import type { Job } from "providers/HostedScrapingProvider";
import { COLOR_OK, COLOR_ERROR, COLOR_GRAY } from "components/hosted-scraping/ProjectColors";
import { ReactComponent as ProjectJobsCheckmark } from "assets/icons/project-jobs-checkmark.svg";
import { ReactComponent as ProjectJobsXIcon } from "assets/icons/project-jobs-x-icon.svg";
import { ClipboardIcon } from "@heroicons/react/outline";
import { Link, useLocation } from "react-router-dom";
import { hasErrorReport } from "components/hosted-scraping/job-list/utils";

const responseStatusFieldStyle = "flex flex-row items-center pr-2 gap-1";

const DownloadErrorReportButton = () => (
  <div className="flex flex-row gap-1 items-center">
    <ClipboardIcon className="w-4 h-4"/>
    <div>Error report</div>
  </div>
);

export const JobResponseStatus = ({job}: {job: Job}) => {
  const location = useLocation();
  const { successfulTasks, failedTasks, cancelledTasks } = job;
  const canDownloadFailureReport = hasErrorReport(job);

  const content = (
    <div className="flex flex-wrap">
      {/* <div className="flex lg:flex-col xs:flex-row"> */}
      <div className="flex flex-col">
        {successfulTasks > 0 &&
          <div className={responseStatusFieldStyle}>
            <ProjectJobsCheckmark stroke={COLOR_OK} fill={COLOR_OK} />
            {successfulTasks}
          </div>}
        {cancelledTasks > 0 && <div className={responseStatusFieldStyle}>
          <ProjectJobsXIcon stroke={COLOR_GRAY} />
          <div>{cancelledTasks}</div>
        </div>}
        {failedTasks > 0 && <div className={responseStatusFieldStyle}>
          <ProjectJobsXIcon stroke={COLOR_ERROR} />
          <div>{failedTasks}</div>
        </div>}
      </div>
      {failedTasks > 0 && <div className="flex flex-wrap flex-col-reverse">
        {canDownloadFailureReport && <DownloadErrorReportButton />}
      </div>}
    </div>
  );
  if (canDownloadFailureReport) {
    return (
      <Link
        to={`/datapipeline/project/${job.projectId}/error-report/${job.publicJobId}`}
        state={{ backgroundLocation: location }}
      >
        {content}
      </Link>
    );
  } else {
    return content;
  }
}
